import { render } from "./CreateShortLinkComponent.vue?vue&type=template&id=2c2050d4&scoped=true"
import script from "./CreateShortLinkComponent.vue?vue&type=script&lang=js"
export * from "./CreateShortLinkComponent.vue?vue&type=script&lang=js"

import "./CreateShortLinkComponent.vue?vue&type=style&index=0&id=2c2050d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2050d4"]])

export default __exports__